<template>
	<div>
		<h1 class="view-title" data-v-step-config="1">
			CONFIGURAÇÕES <span v-popover:tooltip.right="'Seção de configuração geral do sistema'"><i class="fas fa-question-circle"></i></span>
			<button class="btn btn-link btn-right" @click="$refs.tour.editTour()" data-v-step-config="2">
				<i class="fas fa-question-circle"></i> TOUR
			</button>
		</h1>
		<div class="inner-content">
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<div data-v-step-config="3">
						<button class="config-tab" :class="{ 'enabled': (tab == 'Company') }" @click="tab = 'Company'">
							Empresa
						</button>
						<button v-if="$permission.hasAreaPermission('User')" class="config-tab" :class="{ 'enabled': (tab == 'User') }"  @click="tab = 'User'">
							Usuários
						</button>
						<button class="config-tab" :class="{ 'enabled': (tab == 'Config') }" @click="tab = 'Config'">
							Geral
						</button>
						<button v-if="$api.user.company_routing && $permission.hasAreaPermission('DeliveryRouting')" class="config-tab" :class="{ 'enabled': (tab == 'DeliveryRouting') }" @click="tab = 'DeliveryRouting'">
							Roterização
						</button>
						<button v-if="false" class="config-tab" :class="{ 'enabled': (tab == 'Invoice') }" @click="tab = 'Invoice'">
							Planos e pagamentos
						</button>
					</div>
				</div>
			</div>
            <div data-v-step-config="4">
                <div v-if="(tab == 'Company')" class="row config-tab-block" :class="{ 'show': (tab == 'Company') }">
                    <div class="col-xs-12 col-lg-12">
                        <ConfigCompany />
                    </div>
                </div>
                <div v-if="(tab == 'User') && $permission.hasAreaPermission('User')" class="row config-tab-block" :class="{ 'show': (tab == 'User') }">
                    <div class="col-xs">
                        <ConfigUsers />
                    </div>
                </div>
                <div v-if="(tab == 'Config')" class="row config-tab-block" :class="{ 'show': (tab == 'Config') }">
                    <div class="col-xs">
                        <ConfigSettings @updated="settingsUpdated" ref="settings" />
                    </div>
                </div>
                <div v-if="(tab == 'DeliveryRouting') && $api.user.company_routing && $permission.hasAreaPermission('DeliveryRouting')" class="row config-tab-block" :class="{ 'show': (tab == 'DeliveryRouting') }">
                    <div class="col-xs">
                        <ConfigRouting @updated="routerUpdated" ref="router" />
                    </div>
                </div>
                <div v-if="false" class="row config-tab-block" :class="{ 'show': (tab == 'Invoice') }">
                    <div class="col-xs">
                        <ConfigPayment />
                    </div>
                </div>
            </div>
		</div>
        
		<Tour
            tour="Config"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
	</div>
</template>

<script>
import ConfigCompany from "./Config/ConfigCompany";
import ConfigUsers from "./Config/ConfigUsers";
import ConfigSettings from "./Config/ConfigSettings";
import ConfigRouting from "./Config/ConfigRouting";
//import ConfigPayment from "./Config/ConfigPayment";
import Tour from "@/components/Tour";

export default {
	name: "Config",
	components: {
        ConfigCompany,
        ConfigUsers,
        ConfigSettings,
        ConfigRouting,
        //ConfigPayment,
        Tour,
    },

	data: function() {
		return {
			tab: 'Company',
            tour_steps: [
                {
                    target: '[data-v-step-config="0"]',
                    header: {
                        title: '<code>SEÇÃO CONFIGURAÇÃO</code>',
                    },
                    content: '<code>Clique no menu <b>CONFIGURAÇÃO</b> para ir a seção de configiração do perfil</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
                {
                    target: '[data-v-step-config="1"]',
                    header: {
                        title: '<code>SEÇÃO ATUAL</code>',
                    },
                    content: '<code>Identifique pelo título a seção que está atualmente</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-config="2"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
				{
                    target: '[data-v-step-config="3"]',
                    header: {
                        title: '<code>ABAS DE CONFIGURAÇÃO</code>',
                    },
                    content: '<code>Clique nas <b>ABAS DE CONFIGURAÇÃO</b> para mudar a tela de agrupamento de configiração desejada</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-config="4"]',
                    header: {
                        title: '<code>TELAS DE CONFIGURAÇÃO</code>',
                    },
                    content: '<code>Aqui estarão os campos com informações que poderão ser preenchidos para definir os padrões usados pelo perfil</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
		}
	},

	beforeCreate: function() {
        if (!this.$permission.hasAreaPermission("Config")) {
            this.$router.push({ name: 'Home' });
        }
	},

	mounted: function() {
		this.$refs.tour.setTour();
	},

	methods: {
		settingsUpdated: function() {
			this.$refs.settings.load();
		},
		
		routerUpdated: function() {
			this.$refs.router.load();
		},
	}
}
</script>


<style scoped>
.config-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
}

.config-tab.enabled {
	background: #fff;
}


.config-tab-block {
	display: none;
}
.config-tab-block.show {
	display: block;
}
</style>